import { useContext } from 'react'
import { I18nContext } from './context'
import type { I18nContextValue } from './context'

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext)
  if (!ctx) throw new Error('useI18n must be used inside I18nProvider')
  return ctx
}

export function useT(): I18nContextValue['t'] {
  return useI18n().t
}
